// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@steiner/App/Components/Common/XngZone";
import { XNGAGE_ELEMENTS } from "@steiner/XDL/constants";
import React from "react";

type Props = WidgetProps;

export interface CustomCreateAccountStyles {
    leftSide?: InjectableCss;
    rightSide?: InjectableCss;
    container?: InjectableCss;
    contactInformationTypography?: TypographyProps;
}

export const customCreateAccountStyles: CustomCreateAccountStyles = {};

const styles = customCreateAccountStyles;

const CustomCreateAccount = ({ id }: Props) => {
    return (
        <StyledWrapper>
            <XngZone contentId={id} zoneName="Content0" hint="Zone For Title" />
            <StyledWrapper {...styles.container} data-test-selector="createAccountLayout">
                <StyledWrapper {...styles.leftSide}>
                    <Typography as="h2" {...styles.contactInformationTypography}>
                        {translate("Contact Information")}
                    </Typography>
                    <XngZone hint="Existing Account" contentId={id} zoneName="Content1" />
                </StyledWrapper>
                <StyledWrapper {...styles.rightSide}>
                    <XngZone hint="Rich Content Area" contentId={id} zoneName="Content2" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomCreateAccount,
    definition: {
        allowedContexts: ["CreateAccountPage"],
        group: XNGAGE_ELEMENTS,
    },
};

export default widgetModule;
